import { FisReportKind } from './fis-report.const';

/** Translates a key relative to `features.users.reports`. */
export type ReportTextTranslate = (key: string, params?: Record<string, unknown>) => string;

/** `Controlling, Absenzen`, with ` (ZIP)` when several reports share one file. */
export function reportKindsText(kinds: readonly FisReportKind[], t: ReportTextTranslate): string {
  const names = kinds.map((kind) => t(`kind.${kind}`)).join(', ');
  return kinds.length > 1 ? `${names} ${t('list.zip')}` : names;
}

/** `Alle Filialen`, the single branch key, or `12 Filialen`; empty when unknown. */
export function branchKeysText(keys: readonly string[] | null, t: ReportTextTranslate): string {
  if (keys === null) return '';
  if (keys.length === 0) return t('branches.all-label');
  if (keys.length === 1) return keys[0];
  return t('branches.count', { count: keys.length });
}
